<template>
  <section>
    <!-- Testimonials Section
==========================================-->
    <div id="testimonials" class="text-center">
      <div class="overlay">
        <div class="container">
          <div class="section-title center">
            <h2><strong>testimonials</strong></h2>
            <div class="line">
              <hr />
            </div>
          </div>
          <div class="row">
            <div class="col-md-8 col-md-offset-2">
              <carousel :per-page="1" :mouse-drag="false">
                <slide v-for="(testimonial,i) in testimonials" :key="i">
                  <div class="item">
                    <p v-html="testimonial.content.rendered" ></p>
                    <div class="author">- <span v-html="testimonial.title.rendered"></span></div>
                  </div>
                </slide>
               
              </carousel>

             
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
const axios = require("axios")
import { Carousel, Slide } from "vue-carousel";
export default {
  components: {
    Carousel,
    Slide,
  },
  data(){
    return{
      testimonials:[]
    }
  },
  mounted(){
    this.getTestimonials();
  },
  methods:{
    async getTestimonials(){
       var res = await axios({method:"get",url:"https://compu-info-1abfbc.ingress-comporellon.easywp.com/wp-json/wp/v2/posts?categories=3"})
      this.testimonials = res.data
      console.log(this.testimonials)
    }
  }
};
</script>

<style scoped>
.author{
  color:#bfbfbf;
  text-align: right;
}
</style>